const types = {
    GET_EXPAND_BY_IDENTIFICACION: 'GET_EXPAND_BY_IDENTIFICACION',
    GET_EXPAND_BY_PLACA_MOTOR_CHASIS: 'GET_EXPAND_BY_PLACA_MOTOR_CHASIS',
    GET_EXPAND_BY_RUC: 'GET_EXPAND_BY_RUC',
    GET_CONSULTAR_IDENTIFICACION: 'GET_CONSULTAR_IDENTIFICACION',
    GET_CONSULTAR_RUC: 'GET_CONSULTAR_RUC',
    GET_CONSULTAR_PLACA_MOTOR_CHASIS: 'GET_CONSULTAR_PLACA_MOTOR_CHASIS',
    STORE_EXPAND_RESULTS: 'STORE_EXPAND_RESULTS',
    STORE_CONSULTAR_RESULTS: 'STORE_CONSULTAR_RESULTS'
}

export default types;

export const getExpandByIdentificacion = (identificacion, paquetes) => {
    return { type: types.GET_EXPAND_BY_IDENTIFICACION, payload: { identificacion, paquetes } };
}

export const getExpandByPlacaMotorChasis = (identificacion, paquetes) => {
    return { type: types.GET_EXPAND_BY_PLACA_MOTOR_CHASIS, payload: { identificacion, paquetes } };
}

export const getDinardapByIdentificacion = (identificacion, paquetes) => {
    return { type: types.GET_CONSULTAR_IDENTIFICACION, payload: { identificacion, paquetes } };
}

export const getDinardapByRuc = (ruc, paquetes) => {
    return { type: types.GET_CONSULTAR_RUC, payload: { ruc, paquetes } };
}

export const getDinardapByPlacaMotorChasis = (tipoConsultaVehiculo, identificacionVehiculo, paquetes) => {
    return { type: types.GET_CONSULTAR_PLACA_MOTOR_CHASIS, payload: { tipoConsultaVehiculo, identificacionVehiculo, paquetes } };
}

export const storeExpandResults = (identificacion, results) => {
    return { type: types.STORE_EXPAND_RESULTS, payload: { identificacion, results } };
}

export const storeConsultarResults = (identificacion, results) => {
    return { type: types.STORE_CONSULTAR_RESULTS, payload: { identificacion, results } };
}